module.exports = __webpack_public_path__ + "static/media/sarah-icon.ac89d51e.png";